module.exports = __webpack_public_path__ + "fonts/FontsFree-Net-Proxima-Nova-Sbold.f14eee64.otf";